module.exports = __webpack_public_path__ + "static/media/lds-logo_ht.af28721f.svg";